import React from 'react';
import PropTypes from 'prop-types';

import { BaseButton } from '../../../common/base-button';
import iconCartEnabled from './icon-cart-enabled.svg';
import iconCartDisabled from './icon-cart-disabled.svg';
import styles from './AddToCartButton.css';

const IPropTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  buttonText: PropTypes.string,
};

const defaultProps = {
  className: '',
  disabled: false,
  buttonText: 'Agregar al carrito',
};

const AddToCartButton = (props) => {
  const propsToPass = {
    ...props,
    className: [props.className, styles.container].join(' '),
  };
  const iconLink = props.disabled ? iconCartDisabled : iconCartEnabled;

  return (
    <BaseButton
      {...propsToPass}
      disabledClassName={styles.disabled}
      enabledClassName={styles.enabled}
      pressedClassName={styles.pressed}
    >
      <img src={iconLink} alt="" className={styles.cartIcon} />
      <p className={styles.text}>
        {props.buttonText}
      </p>
    </BaseButton>
  );
};

AddToCartButton.propTypes = IPropTypes;
AddToCartButton.defaultProps = defaultProps;

export { AddToCartButton };



// WEBPACK FOOTER //
// ./src/common/add-to-cart-section/add-to-cart-button/AddToCartButton.jsx